/**
 * Check if text is actually truncated when clamped to 4 lines.
 * Measures the actual rendered height by creating a temporary DOM element.
 * @param text - The text to check
 * @param maxWidth - Optional max width for the measurement container (default: 300px)
 * @returns true if text overflows the 4-line clamp
 */
export const isTextTruncated = (text: string, maxWidth: string = '300px'): boolean => {
  if (!text) return false

  // Create a temporary container with the same styles as multiline-clamp-4
  const tempDiv = document.createElement('div')
  tempDiv.style.display = '-webkit-box'
  tempDiv.style.webkitBoxOrient = 'vertical'
  tempDiv.style.webkitLineClamp = '4'
  tempDiv.style.lineClamp = '4'
  tempDiv.style.overflow = 'hidden'
  tempDiv.style.textOverflow = 'ellipsis'
  tempDiv.style.whiteSpace = 'pre-wrap'
  tempDiv.style.maxWidth = maxWidth
  tempDiv.style.position = 'absolute'
  tempDiv.style.visibility = 'hidden'
  tempDiv.style.pointerEvents = 'none'
  tempDiv.style.fontSize = '10px' // Match .small-font table font size
  tempDiv.style.fontFamily = 'inherit'

  tempDiv.textContent = text
  document.body.appendChild(tempDiv)

  // Check if scrollHeight exceeds clientHeight (indicating overflow/truncation)
  const isTruncated = tempDiv.scrollHeight > tempDiv.clientHeight

  // Clean up
  document.body.removeChild(tempDiv)

  return isTruncated
}
